import React from 'react'
import { styled } from '@mui/material/styles'
import T from 'prop-types'
import { MenuItem, Stack } from '@mui/material'
import { useTranslation } from 'react-i18next'

import InputLabel from './InputLabel'
import SelectScrollable from './SelectScrollable'

const StyledSelect = styled(SelectScrollable)(({ theme }) => ({
  '&::before, &::after': {
    border: 'none',
  },
  '&:hover:not(.Mui-disabled):before': {
    border: 'none',
  },
}))

export default function PagePartnersSelect({
  label,
  value,
  partners = [],
  readOnly,
  handleChange = () => {},
}) {
  const { t } = useTranslation()

  return (
    <Stack data-testid="page-partners-select">
      <InputLabel
        label={label || t('common.form.partners')}
        inputId="page-title-partners-select"
        sx={{ pr: 0.5 }}
      />
      <StyledSelect
        data-testid="page-title-partners-select"
        id="page-title-partners-select"
        variant="standard"
        size="small"
        value={value || ''}
        readOnly={readOnly}
        onChange={handleChange}
      >
        {partners.map((partner) => {
          return (
            <MenuItem key={partner.partnerId} value={partner.partnerId}>
              {partner.name}
            </MenuItem>
          )
        })}
      </StyledSelect>
    </Stack>
  )
}

PagePartnersSelect.propTypes = {
  label: T.string,
  value: T.string,
  partners: T.array,
  readOnly: T.bool,
  renderIcon: T.func,
  handleChange: T.func,
}
